import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** External user access control settings common request and response body - DTO signature */
export interface ExternalUserAccessControlInterface {
  /** If `true` then external user has access to all operations */
  admin?: boolean;
  /** If `true` then external user has access to external users write oeprations */
  externalUser?: boolean;
  /** If `true` then user has access to HD tasks write operations */
  hdTask?: boolean;
  /** If `true` then user has access to CCTV transit tasks write operations */
  cctvTransitTask?: boolean;
  /** If `true` then user has access to CCTV resident cars write operations */
  cctvResidentCar?: boolean;
  /** If `true` then user has access to PACS passage tasks write operations */
  pacsPassageTask?: boolean;
  /** If `true` then user has access to PACS passage orders write operations */
  pacsPassageOrder?: boolean;
}

/** Default external user access control settings */
export const DEFAULT_ACCESS_CONTROL: ExternalUserAccessControlInterface = {
  admin: false,
  externalUser: false,
  hdTask: true,
  cctvTransitTask: false,
  cctvResidentCar: false,
  pacsPassageTask: false,
  pacsPassageOrder: false,
};

/** External user access control settings common request and response body - DTO schema */
export const ExternalUserAccessControlDto = SerdeDtoClass.create<ExternalUserAccessControlInterface>(SecurityDtoKeysEnum.EXTERNAL_USER_ACCESS_CONTROL_DTO, {
  admin: {
    optional: true,
    label: 'Полный доступ к ЛК',
    hint: 'Включение этого разрешения эквивалентно включению всех остальных разрешений сразу',
    serializer: yup.boolean(),
  },
  externalUser: {
    optional: true,
    label: 'Сотрудники',
    hint: 'Создание и редактирование профилей, блокировка учетной записи, настройка прав для всех сотрудников, а еще выдача доступа в Личный кабинет',
    serializer: yup.boolean(),
  },
  hdTask: {
    optional: true,
    label: 'Заявки',
    hint: 'Создание заявки и редактирование ее реквизитов',
    serializer: yup.boolean(),
  },
  cctvTransitTask: {
    optional: true,
    label: 'Гостевой проезд',
    hint: 'Создание заявки на гостевой проезд и редактирование ее реквизитов в статусе "Новая"',
    serializer: yup.boolean(),
  },
  cctvResidentCar: {
    optional: true,
    label: 'Постоянные ТС',
    hint: 'Создание, редактирование и удаление постоянных ТС',
    serializer: yup.boolean(),
  },
  pacsPassageTask: {
    optional: true,
    label: 'Приглашение гостя',
    hint: 'Создание заявки по приглашению гостя и редактирование ее реквизитов в статусе "Новая", а еще повтор заявки',
    serializer: yup.boolean(),
  },
  pacsPassageOrder: {
    optional: true,
    label: 'Заказ пропусков',
    hint: 'Создание заявки по оформлению постоянных пропусков для сотрудников и редактирование ее реквизитов в статусе "Новая"',
    serializer: yup.boolean(),
  },
});
